import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const ACTIONS_SLICE_FEATURE_KEY = 'actionsSlice';

export interface Action {
  aiworker_id: string;
  name: string;
  description: string;
  status: string;
  category: string;
  type: string;
  sub_type: string;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
  is_public: boolean;
  is_default: boolean;
  aiworkers_attrs: any[];
}

export interface ActionsState {
  actions: Action[];
}

const initialState: ActionsState = {
  actions: []
};

export const actionsSlice = createSlice({
  name: ACTIONS_SLICE_FEATURE_KEY,
  initialState,
  reducers: {
    updateActionsData: (state, action: PayloadAction<Action[]>) => {
      state.actions = action.payload;
    }
  }
});

export const { updateActionsData } = actionsSlice.actions;

export default actionsSlice.reducer;
